exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".分享{margin:1em 0;text-align:center}.分享 span{font-size:120%;margin:0 5px}.分享 iframe{vertical-align:top;margin:0 5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/GuanKiann/分享鍵/分享鍵.css
// module id = 661
// module chunks = 0